import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import { getFilteredSpaceGroup } from '../../../../util/circleHelper';
import RequestSpaceForm from './RequestSpaceForm';
import css from './SpaceGroups.module.css';
import { createTicketEventIDs, REQUEST_GROUP_TEMPLATE_ID } from '../../../../util/types';

const RequestSpaceModal = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {
    isRequestSpace,
    onRequestGroupClick,
    spaceListData = [],
    requestNewSpace,
    currentUser,
    onRequestSpace,
    loading,
    onManageDisableScrolling
  } = props;
  const { email, profile } = currentUser?.attributes || {};
  const { firstName, lastName } = profile || {};

  const removeRequestGroupQueryParam = () => {
    const searchParams = new URLSearchParams(location.search || '');
    searchParams.delete('requestGroup');
    const nextSearch = searchParams.toString();

    history.replace({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash,
    });
  };

  const handleClose = () => {
    removeRequestGroupQueryParam();
    onRequestGroupClick(false);
  };

  const handleCreateNewSpace = async (values, form) => {
    const {
      accessType,
      spaceGroup,
      spaceTitle,
      spaceDescription,
      desktopBanner,
      mobileBanner,
    } = values;

    const data = {
      userName: firstName + ' ' + lastName,
      userEmail: email,
      groupName: spaceTitle,
      groupCategory: spaceGroup,
      groupDescription: spaceDescription,
      accessPermission: accessType,
      email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
      name: process.env.REACT_APP_SENDGRID_SENDER_NAME,
      desktopBanner: typeof desktopBanner == "string" ? desktopBanner : "",
      mobileBanner: typeof mobileBanner == "string" ? mobileBanner : "",
    };
    // const sendGridMailData = {
    //   data,
    //   template_id: REQUEST_GROUP_TEMPLATE_ID
    // };

    const createTicketData = {
      ticketTypeId: createTicketEventIDs["Group Request"],
      attributes: {
        name: firstName + ' ' + lastName,
        userEmail: email,
        userId: currentUser?.id?.uuid,
        groupName: spaceTitle || "",
        groupCategory: spaceGroup || "",
        groupDescription: spaceDescription || "",
        accessPermission: accessType || "",
        desktopBanner: typeof desktopBanner == "string" ? desktopBanner : "",
        mobileBanner: typeof mobileBanner == "string" ? mobileBanner : "",
      },
      assignment: true
    };

    return onRequestSpace(createTicketData).then(() => { form.restart(); });
  };


  return (
    <>
     {isRequestSpace ?  <Modal
        id="requestSpaceModal"
        isOpen={isRequestSpace}
        onClose={handleClose}
        onManageDisableScrolling={onManageDisableScrolling}
        classname={css.requestModal}
      >
        <RequestSpaceForm
          onSubmit={(values, form) => {}}
          spaceGroups={getFilteredSpaceGroup(spaceListData)}
          requestNewSpace={requestNewSpace}
          loading={loading}
          handleCreateNewSpace={handleCreateNewSpace}
        />
      </Modal> : null}
    </>
  );
};

export default RequestSpaceModal;
